import StimulusCarousel from '@stimulus-components/carousel'

export default class CarouselStimulusController extends StimulusCarousel {
  static values = {
    slidesPerView: Number,
    navigation: Boolean,
    keyboard: Boolean,
  };

  static targets = ['swiperButtonPrev', 'swiperButtonNext'];

  connect() {
    super.connect();

    this.swiper;

    this.defaultOptions;
  }

  get defaultOptions() {
    // Swiper wires one listener per element, so several buttons can drive the same
    // direction — a duplicated pair shown only on mobile for instance.
    const navigationOptions = {
      nextEl: this.swiperButtonNextTargets,
      prevEl: this.swiperButtonPrevTargets,
    };

    return {
      slidesPerView: this.slidesPerViewValue,
      navigation: this.navigationValue ? navigationOptions : false,
      loop: false,
      keyboard: { enabled: this.keyboardValue, pageUpDown: false },
    };
  }
}
